export const list = (dispatch, apiClient, data) => apiClient
  .call({
    endpoint: 'product/list',
    data,
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'PRODUCTS_SET', products: res.data });
    return res;
  });

export const getByCatalogID3DCart = (dispatch, apiClient, id) => apiClient
  .call({
    endpoint: 'product/getByCatalogID3DCart',
    data: { id },
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'PRODUCTS_SET', products: res.data });
    return res;
  });

export const refresh3dCart = (apiClient) => apiClient
  .call({ endpoint: 'product/refresh3dCart' })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    return res;
  });

export const update = (dispatch, apiClient, id, data = {}) => apiClient
  .call({ endpoint: 'product/update', data: { ...data, id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'PRODUCTS_SET', products: res.data });
    return res;
  });

export const dummy = '';



// WEBPACK FOOTER //
// ./app/actions/products.js